import type { LucideIcon } from 'lucide-react';

/**
 * 跟着文字走的小图标:大小随字号(1.15em),颜色随文字(currentColor)。
 *
 * ★ 界面上原来全是 emoji(🏪 🧭 📞 …)。emoji 靠系统的彩色 emoji 字体 ——
 *   iOS 26.3 模拟器里这个字体缺资源,所有图标都是「?」方块,
 *   整个 App 看起来像乱码。真机上没事,但图标不该押在字体上:
 *   emoji 跟着系统版本换画风,也不吃 `text-red-600` 这类颜色 ——
 *   「这一单要收钱」那行字是红的,前面的 💰 还是黄的。
 *
 *   图标是装饰,文字已经说清了意思,所以一律 aria-hidden(Lucide 默认就是);
 *   只有图标、没有字的按钮,要在按钮上写 aria-label。
 */
export function InlineIcon({ icon: C, className = '' }: { icon: LucideIcon; className?: string }) {
  return <C className={`inline-block size-[1.15em] align-[-0.2em] shrink-0 ${className}`} />;
}
